'use strict';

const { h } = require('phy');

const MerchantLogoImage = require('../../shared/views/merchants/merchant-logo-image');

function CouponSmall({ routes, coupon = {} }) {
  const { offerTitle, merchant } = coupon;

  return h(
    '.coupon-small',
    h(
      'a.coupon-small-link',
      {
        href: routes.merchant.show.replace(
          '{merchantSlug}',
          merchant.merchantSlug
        ),
        'data-bhc': `category-merchant:${merchant.merchantSlug}`,
      },
      [
        h('.coupon-small-logo', [
          MerchantLogoImage({
            data: coupon && coupon.merchant && coupon.merchant.merchantMedia,
            alt: `${coupon.merchant.merchantName} - ${coupon.calloutValue}`,
            size: ['w_100,h_100'],
          }),
        ]),
        h('p.coupon-small-title', offerTitle),
      ]
    )
  );
}

module.exports = CouponSmall;
